/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_SubheadingInputs */

const et_portfolio_subheading = /** @type {(inputs: Portfolio_SubheadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valik meie hiljutistest projektidest ja klientide tulemustest.`)
};

const en_portfolio_subheading = /** @type {(inputs: Portfolio_SubheadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A selection of our recent projects and client results.`)
};

/**
* | output |
* | --- |
* | "A selection of our recent projects and client results." |
*
* @param {Portfolio_SubheadingInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_subheading = /** @type {((inputs?: Portfolio_SubheadingInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_SubheadingInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_subheading(inputs)
	return en_portfolio_subheading(inputs)
});